import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog'

import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useToast } from '@/components/ui/use-toast'
import { deleteParameterConferenceHub } from '@/api/business/processhub'
import { ParameterConferenceHubKeys } from '@/queries/useParameterConferenceHubQuery'
import { isAxiosError } from '@/api/business'
import Button from '@/components/Button'

interface DeleteDialogProps {
    ids: (string | number)[]
    isOpen: boolean
    onClose: () => void
}

const DeleteDialog = ({ ids, isOpen, onClose }: DeleteDialogProps) => {
    const queryClient = useQueryClient()
    const { toast } = useToast()

    const { mutate: mutateDelete, isPending: mutateLoading } = useMutation({
        mutationFn: deleteParameterConferenceHub,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ParameterConferenceHubKeys.lists() })
            onClose()
            toast({
                title: 'Parametro Hub excluido com sucesso',
            })
        },
        onError: (err) => {
            let errorMessage =
                'Não foi possível excluir o parametro hub. Tente novamente mais tarde.'

            if (isAxiosError(err)) {
                errorMessage = err.response?.data.message || errorMessage
            }

            toast({
                title: 'Erro ao excluir parametro hub',
                description: errorMessage,
                variant: 'destructive',
            })
        },
    })

    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent aria-describedby=''>
                <DialogHeader>
                    <DialogTitle>Excluir Parâmetro de Confêrencia Hub</DialogTitle>
                </DialogHeader>
                <div className="pt-4">
                    <p>
                        Realmente deseja excluir
                        <span className="font-bold"> {ids.length}</span> ite{ ids.length > 1 ? 'ns' : 'm'}?
                    </p>
                </div>
                <DialogFooter>
                    <Button onClick={onClose} variant="ghost">
                        Cancelar
                    </Button>
                    <Button
                        onClick={() => mutateDelete({ SK_PARAMETRO_CONFERENCIA_HUB: ids })}
                        isLoading={mutateLoading}
                    >
                        Confirmar
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}

export default DeleteDialog
